import React from "react";
import { TextField, Typography, Box } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const SingleDateInput = ({
  label,
  name,
  value,
  onChange,
  isRequired = false,
  error = false,
}) => (
  <Box>
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      <Typography sx={{ fontSize: 14 }}>{label}</Typography>
      <RequiredLabel show={isRequired} />
    </Box>
    <TextField
      type="date"
      name={name}
      value={value ?? ""}
      onChange={onChange}
      InputLabelProps={{ shrink: true }}
      error={error}
      fullWidth
    />
  </Box>
);

export default SingleDateInput;
